import React from 'react';
import {Button, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from './img/Explore with line.webp'
import img2 from './img/Curated with line.webp'
import img3 from './img/Partnering with line.webp'
import img4 from './img/Connecting with line.webp'
import img5 from './img/Playlists with line.webp'
import {ReactComponent as HeadLogo} from './img/Curated Logo.svg'
import {TitleText} from "./text";
import './style.scss'

const CuratedCollections = (props) => {
    return (
        <Layout>
            <Content>
                <Row justify={"center"} style={{
                    margin: '2rem 0 0 0'
                }}>
                    <HeadLogo/>
                </Row>
                <Row justify={"center"} style={{
                    margin: '0 0 2rem 0'
                }}>
                    {TitleText.map((txt, idx) => {
                        return (
                            idx === 0 ? <p className={'curated-txt'} key={idx}
                                           style={{margin: '-5rem 0 0 0'}}
                                >
                                    {txt}
                                </p> :
                                <p className={'curated-txt'}
                                   key={idx}
                                   style={{margin: '-3rem 0 0 0'}}
                                >
                                    {txt}
                                </p>
                        )
                    })}
                </Row>
                <Row justify={"center"}>
                    <Button className={'dsa-btn pro-btn-hover-to-white'}
                            onClick={() => {
                                window.location.href='/proportal/discover-art'
                            }}
                    >
                        Discover Art
                    </Button>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img1} alt={img1} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Explore Art & Get Inspired
                            </p>
                            <p className={'curated-p'}>
                                Discover the Vieunite Art Library and explore a unique collection of artwork and playlists that perfectly suit your business needs.
                                From classic art pieces to contemporary photography, Vieunite Pro offers a diverse range of artwork to display on the Textura digital canvas.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container" style={{width:'100%'}}>
                        <img src={img2} alt={img2} className="curated-overlay-image" style={{width:'100%'}}/>
                        <div className="curated-text-overlay curated-overlay-left">
                            <p className={'curated-h1'}>
                                Curated Artwork
                            </p>
                            <p className={'curated-p'}>
                                With Vieunite Pro you gain access to thousands of high-quality and carefully selected artwork, encompassing both contemporary and classic art.
                                You can browse the artwork based on your specific business industry, personal preferences, or requirements.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img3} alt={img3} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Partnering With Artists
                            </p>
                            <p className={'curated-p'}>
                                Featuring over 200 artists, our collection includes works by both young contemporary artists and renowned, established artists.
                                You can not only support your favourite creatives, but also have exclusive access to timeless masterpieces from worldwide known artist.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container" style={{width:'100%'}}>
                        <img src={img4} alt={img4} className="curated-overlay-image" style={{width:'100%'}}/>
                        <div className="curated-text-overlay curated-overlay-left">
                            <p className={'curated-h1'} style={{color:"white"}}>
                                Connecting You to Galleries
                            </p>
                            <p className={'curated-p'} style={{color:"white"}}>
                                We actively collaborate with renowned and emerging art museums and galleries worldwide, allowing you to explore a thoughtfully curated selection of artwork.
                                You will have exclusive access to the finest art from the collections of major museums and art galleries.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row justify={"center"}>
                    <div className="curated-image-overlay-container">
                        <img src={img5} alt={img5} className="curated-overlay-image"/>
                        <div className="curated-text-overlay">
                            <p className={'curated-h1'}>
                                Curated Playlists
                            </p>
                            <p className={'curated-p'}>
                                With our Advanced subscription plan you gain unrestricted access to all the playlists, featuring both classic pieces and contemporary work.
                                Alternatively, you can upgrade to our Premium option to get access to a personalised and exclusive playlist crafted by our team, tailored to your style and business aesthetics.
                            </p>
                        </div>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default CuratedCollections;
